<template>
	<b-modal
          id="taskTemplateModal"
          ref="taskTemplateModal"
          :title="localTaskTemplate.name"
          size="lg"
		:centered="true"
		:scrollable="true">

		<template v-slot:default="{}">

			<b-container class="modal-body-lg">

				<b-row>

					<b-col>
						<p>
							<!-- {{localTaskTemplate.description}} -->
							<vue-markdown :source="localTaskTemplate.description" />
						</p>
					</b-col>

				</b-row>

				<b-row>
					<b-col>
						<b-list-group>

							<b-list-group-item 
								v-for="(task, taskIndex) in tasksForList" 
								:key="taskIndex"
								:variant="task.variant">

								{{task.title}}

							</b-list-group-item>


							<!-- <b-list-group-item variant="primary">Cras justo odio</b-list-group-item>
							<b-list-group-item variant="light">Dapibus ac facilisis in</b-list-group-item> -->
						</b-list-group>
					</b-col>
				</b-row>

				

				

			</b-container>

		</template>

		<template v-slot:modal-footer="{ close }">
			
			<b-button size="md" variant="warning" @click="close()">
				Close
			</b-button>
			
			<b-button 
				v-if="enableDeleteButton"
				id="delete-template-button"
				size="md" 
				variant="danger" 
				@click="deleteTemplate()">
				Delete
			</b-button>

			<b-tooltip 
				v-if="enableDeleteButton"
				target="delete-template-button" 
				triggers="hover"
				variant="danger"
				placement="topleft">
				Remove this template from your personal gallery.  This does not affect the public gallery.
			</b-tooltip>
			
			<b-button 
				v-if="enableUseButton"
				id="use-template-button"
				size="md" 
				variant="success" 
				@click="useTemplate()">
				Use
			</b-button>
			
			<b-tooltip 
				v-if="enableUseButton"
				target="use-template-button" 
				triggers="hover"
				variant="success">
				Create the task(s) defined by this template.
			</b-tooltip>
			
			<b-button 
				v-if="enableImportButton && isPremiumUser()"
				id="import-template-button"
				size="md" 
				variant="success" 
				@click="importTemplate()">
				Import
			</b-button>

			<b-tooltip 
				v-if="enableImportButton && isPremiumUser()"
				target="import-template-button" 
				triggers="hover"
				variant="success"
				placement="topleft">
				Import the template into your personal gallery.
			</b-tooltip>

			<b-button 
				v-if="enableImportButton && !isPremiumUser()"
				id="import-template-button"
				size="md" 
				variant="light">
				Import
			</b-button>
			
			<PremiumTooltip
				v-if="enableImportButton && !isPremiumUser()"
				target="import-template-button" 
				triggers="hover"
				variant="warning"
				placement="topleft"/>

			<b-button 
				v-if="enablePublishButton"
				id="publish-template-button"
				size="md" 
				variant="success" 
				@click="publishTemplate()">
				Publish
			</b-button>
			
			<b-tooltip 
				v-if="enablePublishButton"
				target="publish-template-button" 
				triggers="hover"
				variant="success"
				placement="topleft">
				Publish this template to the public gallery for everyone to use.
			</b-tooltip>
		</template>



	</b-modal>
</template>

<script>

import genericOps from '@/mixins/genericOps.js'
import PremiumTooltip from '@/components/PremiumTooltip.vue'
import VueMarkdown from 'vue-markdown'

export default {
	name: 'TaskTemplatePopup',
	mixins: [genericOps],
	components: {
		PremiumTooltip,
		'vue-markdown': VueMarkdown,
	},
	props: {
		taskTemplate: {
			type: Object,
               default: {
				name: '',
				tasks: []
			},
		}
	},
	data() {
		return {

		}
	},
	computed: {
		enableDeleteButton: {
			get() {
				if(typeof this.$store.getters.getUser != 'undefined' && this.$store.getters.getUser !== null &&
				this.localTaskTemplate.owner == this.$store.getters.getUser._id) {
					return true
				} else {
					return false
				}
			}
		},
		enableImportButton: {
			get() {
				
				if(typeof this.$store.getters.getUser != 'undefined' && this.$store.getters.getUser !== null) {
					return this.localTaskTemplate.public
				} else {
					return false
				}
				
				
			}
		},
		enablePublishButton: {
			get() {
				if(typeof this.$store.getters.getUser != 'undefined' && this.$store.getters.getUser !== null &&
				this.localTaskTemplate.owner == this.$store.getters.getUser._id &&
				!this.localTaskTemplate.public) {
					return true
				} else {
					return false
				}
			}
		},
		enableUseButton: {
			get() {
				
				if(!this.$auth.loading && this.$auth.isAuthenticated) {
					return true
				} else {
					return false
				}
				
				
			}
		},
		localTaskTemplate: {
			get() {
				return this.taskTemplate
			},
			set(newValue) {

			}
		},
		tasksForList: {
			
			// 20201003 -- ZWS -- Flatten tasks and their children so that the list is prettier.
			
			get() {
				
				let list = []

				if(typeof this.localTaskTemplate.tasks !== 'undefined' && this.localTaskTemplate.tasks !== null) {

					this.localTaskTemplate.tasks.forEach((task, index) => {
						let temp = task
						temp.variant = 'primary'
						list.push(temp)

						if(typeof task.children !== 'undefined' && task.children !== null) {
						
							task.children.forEach((child, childIndex) => {
								let temp2 = child
								temp2.variant = 'light'
								list.push(temp2)
							})

						}

					})

				}

				

				return list
			}
		}
	},
	methods: {
		deleteTemplate() {
			this.$emit('delete:template', this.localTaskTemplate)
		},
		importTemplate() {
			this.$emit('import:template', this.localTaskTemplate)
		}, 
		publishTemplate() {
			this.$emit('publish:template', this.localTaskTemplate)
		}, 
		useTemplate() {
			this.$emit('instantiate:template', this.localTaskTemplate)
		}
	}
}
</script>